// Per-device usage counts (favorite dishes, frequent kitchen notes). A convenience only: storage may be unavailable.
const LIMIT = 60

function read(key: string): Record<string, number> {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) ?? '{}')
    return value && typeof value === 'object' ? value as Record<string, number> : {}
  } catch { return {} }
}

export function remember(key: string, value: string) {
  if (!value) return
  const counts = read(key)
  counts[value] = (counts[value] ?? 0) + 1
  const kept = Object.fromEntries(Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, LIMIT))
  try { localStorage.setItem(key, JSON.stringify(kept)) } catch { /* Favorites are optional. */ }
}

/** Most used first. */
export function mostUsed(key: string, count: number): string[] {
  return Object.entries(read(key)).filter(([, n]) => typeof n === 'number').sort((a, b) => b[1] - a[1]).slice(0, count).map(([value]) => value)
}
